import React, { useState, useRef, useEffect } from "react";
import useAuth from "../../../Hooks/useAuth";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import Masonry from "masonry-layout";
import BusinessDetailsWidget from "../../../components/BusinessDashboard/BusinessDetailsWidget";
import AboutBusinessWidget from "../../../components/BusinessDashboard/AboutBusinessWidget";
import SpecialitiesWidget from "../../../components/BusinessDashboard/SpecialitiesWidget";
import LocationAreasWidget from "../../../components/BusinessDashboard/LocationAreasWidget";
import OperatingHoursWidget from "../../../components/BusinessDashboard/OperatingHoursWidget";
import PublicContactWidget from "../../../components/BusinessDashboard/PublicContactWidget";
import AcceptedPaymentsWidget from "../../../components/BusinessDashboard/AcceptedPaymentsWidget";
import MediaUploadWidget from "../../../components/BusinessDashboard/MediaUploadWidget";
import SocialMediaWidget from "../../../components/BusinessDashboard/SocialMediaWidget";
import MembershipWidget from "../../../components/BusinessDashboard/MembershipWidget";
import ContactWidget from "../../../components/BusinessDashboard/ContactWidget";

const Account = ({ setFieldValue, values, errors }) => {
  const { auth } = useAuth();

  const isProPlan = auth?.userPlan?.plan?.name?.toLowerCase() === "pro";

  const masonryGridRef = useRef(null);
  useEffect(() => {
    if (masonryGridRef.current) {
      try {
        const images = masonryGridRef.current.querySelectorAll("img");
        const imagePromises = Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        });
        Promise.all(imagePromises).then(() => {
          if (masonryGridRef.current && typeof Masonry !== "undefined") {
            const masonry = new Masonry(masonryGridRef.current, {
              itemSelector: ".masonry-item",
              columnWidth: 10,
              gutter: 0,
            });
            const handleResize = () => masonry?.layout?.();
            window.addEventListener("resize", handleResize);
            masonryGridRef.current.masonry = masonry;
            return () => {
              window.removeEventListener("resize", handleResize);
              masonryGridRef.current?.masonry?.destroy();
            };
          }
        });
      } catch (e) {
        console.log("Masonry failed to init on account page:", e);
      }
    }
  }, []);

  return (
    <div className="w-full mx-auto">
      <div ref={masonryGridRef} className="masonry-grid">
        <BusinessDetailsWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        <AboutBusinessWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        <SpecialitiesWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        <LocationAreasWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        <MediaUploadWidget errors={errors} />
        {isProPlan && (
          <ContactWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        )}
        <MembershipWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        <OperatingHoursWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        {isProPlan && (
          <SocialMediaWidget setFieldValue={setFieldValue} values={values} errors={errors} />
        )}
        <AcceptedPaymentsWidget setFieldValue={setFieldValue} values={values} errors={errors} />
      </div>
    </div>
  );
};

export default Account;
